import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Paper, ActionForm, Button, Table, DateTimePicker, showSuccess } from 'components';
import { showApiError } from 'utils';
import { getAllActions, completeAction, snoozeAction } from 'services';
import { actionsListColumns } from './config';
import { actionsTableWrap } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var snoozeBarStyle = function snoozeBarStyle(theme) {
  return {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '1.2em',
    padding: '1.2em 2em',
    marginBottom: '1em',
    backgroundColor: theme.warningLight,
    border: "1px solid ".concat(theme.warning),
    '& .snooze-icon': {
      fontSize: '2rem',
      color: theme.warning,
      flexShrink: 0,
      marginBottom: '0.4em'
    },
    '& .snooze-picker': {
      flex: '0 0 200px',
      '& > div': {
        marginBottom: 0
      }
    },
    '& .snooze-actions': {
      display: 'flex',
      gap: '0.6em',
      flexShrink: 0,
      paddingBottom: '1px'
    }
  };
};

var CreditActionsTab = function CreditActionsTab(_ref) {
  var creditId = _ref.creditId;
  var tableRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAddEdit = _useState2[0],
      setIsAddEdit = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      snoozeActionId = _useState4[0],
      setSnoozeActionId = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      snoozeDate = _useState6[0],
      setSnoozeDate = _useState6[1];

  var fetchActions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getAllActions, _yield$getAllActions2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllActions(_objectSpread(_objectSpread({}, tableOptions), {}, {
                creditId: creditId
              }));

            case 2:
              _yield$getAllActions = _context.sent;
              _yield$getAllActions2 = _slicedToArray(_yield$getAllActions, 2);
              res = _yield$getAllActions2[0];
              err = _yield$getAllActions2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 9:
              return _context.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchActions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleComplete = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(actionId) {
      var _tableRef$current;

      var _yield$completeAction, _yield$completeAction2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return completeAction(actionId);

            case 2:
              _yield$completeAction = _context2.sent;
              _yield$completeAction2 = _slicedToArray(_yield$completeAction, 2);
              err = _yield$completeAction2[1];

              if (!err) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 7:
              showSuccess('Действието е маркирано като завършено.');
              (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getData();

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleComplete(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSnoozeOpen = function handleSnoozeOpen(actionId) {
    setSnoozeActionId(actionId);
    setSnoozeDate(null);
  };

  var handleSnoozeConfirm = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _tableRef$current2;

      var formatted, _yield$snoozeAction, _yield$snoozeAction2, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (snoozeDate) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              formatted = moment.isMoment(snoozeDate) ? snoozeDate.format('YYYY-MM-DD') : snoozeDate;
              _context3.next = 5;
              return snoozeAction(snoozeActionId, formatted);

            case 5:
              _yield$snoozeAction = _context3.sent;
              _yield$snoozeAction2 = _slicedToArray(_yield$snoozeAction, 2);
              err = _yield$snoozeAction2[1];

              if (!err) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 10:
              showSuccess('Действието е отложено.');
              setSnoozeActionId(null);
              setSnoozeDate(null);
              (_tableRef$current2 = tableRef.current) === null || _tableRef$current2 === void 0 ? void 0 : _tableRef$current2.getData();

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSnoozeConfirm() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleSnoozeCancel = function handleSnoozeCancel() {
    setSnoozeActionId(null);
    setSnoozeDate(null);
  };

  var callbacks = {
    onComplete: handleComplete,
    onSnooze: handleSnoozeOpen
  };

  var handleHeaderButton = function handleHeaderButton() {
    setIsAddEdit(function (prev) {
      return !prev;
    });
  };

  var handleSubmit = function handleSubmit() {
    var _tableRef$current3;

    (_tableRef$current3 = tableRef.current) === null || _tableRef$current3 === void 0 ? void 0 : _tableRef$current3.getData();
    setIsAddEdit(false);
  };

  return ___EmotionJSX(Row, {
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref5) {
      var css = _ref5.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F"), ___EmotionJSX(Button, {
        small: true,
        onClick: handleHeaderButton
      }, !isAddEdit ? 'Добави' : 'Затвори'));
    },
    margin: "0 0 2em 0"
  }, isAddEdit ? ___EmotionJSX(ActionForm, {
    creditId: creditId,
    onSubmit: handleSubmit
  }) : ___EmotionJSX(React.Fragment, null, snoozeActionId && ___EmotionJSX("div", {
    css: snoozeBarStyle
  }, ___EmotionJSX("i", {
    className: "las la-clock snooze-icon"
  }), ___EmotionJSX("div", {
    className: "snooze-picker"
  }, ___EmotionJSX(DateTimePicker, {
    small: true,
    label: "\u041E\u0442\u043B\u043E\u0436\u0438 \u0434\u043E",
    value: snoozeDate,
    onChange: setSnoozeDate,
    timeFormat: false,
    dateFormat: "YYYY-MM-DD"
  })), ___EmotionJSX("div", {
    className: "snooze-actions"
  }, ___EmotionJSX(Button, {
    small: true,
    color: "white",
    backColor: "#D97706",
    hoverBackColor: "#B45309",
    onClick: handleSnoozeConfirm
  }, "\u041E\u0442\u043B\u043E\u0436\u0438"), ___EmotionJSX(Button, {
    small: true,
    type: "secondary",
    onClick: handleSnoozeCancel
  }, "\u041E\u0442\u043A\u0430\u0437"))), ___EmotionJSX("div", {
    css: actionsTableWrap
  }, ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    fillUpUrlParams: false,
    getDataMethod: fetchActions,
    columns: actionsListColumns(callbacks),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    pageSize: 20
  }))))));
};

CreditActionsTab.propTypes = {
  creditId: PropTypes.number
};
export default CreditActionsTab;